import mongoose from 'mongoose';
import serviceGroup, { IServiceGroupDocument } from '../schemas/serviceGroup';

const ServiceGroup = (mongoose.models.ServiceGroup ||
  mongoose.model<IServiceGroupDocument>('ServiceGroup', serviceGroup)) as mongoose.Model<
  IServiceGroupDocument
>;

export default ServiceGroup;
